
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import "slick-carousel/slick/slick.css"; 

import BackToTop from './components/parts/BackToTop'
import Header from "./components/sections/Header";
import Footer from "./components/sections/Footer";
import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import Services from "./components/pages/Services";
import About from "./components/pages/About";
import CookieConsent from "react-cookie-consent";
import TherapyYoga from "./components/pages/TherapyYoga";
import ThetaHealing from "./components/pages/ThetaHealing";
import ZvucnaMasaza from "./components/pages/ZvucnaMasaza";
import BlogList from './components/pages/BlogList';
import BlogSingle from './components/pages/BlogSingle';
import Cjenik from "./components/pages/Cjenik";
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <Router>
    <div className="App">
 <Header />

<CookieConsent
  location="bottom"
  buttonText="U redu"
  cookieName="zenplace_cookie_consent"
  style={{ background: "#0E5C63" }}
  buttonStyle={{ background: "#84D99C", color: "#000" }}
  expires={150}
>
  Koristimo kolačiće kako bismo poboljšali korisničko iskustvo i funkcionalnost stranice.
</CookieConsent>
<Routes>
<Route index element={<Home />} />
<Route path="/services" element={<Services />} />
<Route path="/about" element={<About />} />
<Route path="/contact" element={<Contact />} />
<Route path="/TherapyYoga" element={<TherapyYoga />} />
<Route path="/ThetaHealing" element={<ThetaHealing />} />
<Route path="/ZvucnaMasaza" element={<ZvucnaMasaza />} />
<Route path="/BlogList" element={<BlogList />} />
<Route path="/blog/:id" element={<BlogSingle />} />
<Route path="/Cjenik" element={<Cjenik />} />
</Routes>
 <BackToTop />
  <Footer />
    </div>
    </Router>
  );
}

export default App;
